const defaultState = {
    isLogin: false,
    notQualifiedType: '',
    notQualifiedErrInfo: {},
    // 登入當下會拿到 currentLoginID
    currentLoginID: '',
    // 每次 promo init 載入都會拿 登入過的 user 資料
    loginId: ''
};

const UPDATE_USER_LOGIN_STATE = 'userLoginState/UPDATE_USER_LOGIN_STATE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_USER_LOGIN_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export function setCurrentLoginID(currentLoginID) {
    return {
        type: UPDATE_USER_LOGIN_STATE,
        payload: {
            currentLoginID
        }
    };
}

export function setLoginId(loginId) {
    return {
        type: UPDATE_USER_LOGIN_STATE,
        payload: {
            loginId
        }
    };
}

export function setNotQualifiedType(value) {
    return {
        type: UPDATE_USER_LOGIN_STATE,
        payload: {
            notQualifiedType: value
        }
    };
}

export default reducer;
